export default __webpack_public_path__ + "media/images/forgot-password-c8dc2cb4.jpg";